import SpinLoading from '@/components/loading/SpinLoading';
import { useGetDataPosition } from '@/components/trading-panel/hooks/useGetPosition';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Empty from './Empty';
import Item from './item';

export default function PositionOrders() {
    const navigate = useNavigate();

    const location = useLocation();

    const { data } = useGetDataPosition();

    const { isOpened } = location.state || {};

    const [isLoading, setIsLoading] = useState(() => {
        return isOpened;
    });

    useEffect(() => {
        navigate(location.pathname, { replace: true, state: {} });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const prevLengthRef = useRef(data.length);
    const handleCloseLoading = useCallback(() => {
        setIsLoading(false);
        if (location.state?.isOpened) {
            // Dùng xong state, replace lại để xoá nó
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.pathname, location.state?.isOpened, navigate]);

    useEffect(() => {
        if (!isLoading) return;

        // Nếu data mới nhiều hơn data cũ => tắt loading

        if (data.length > prevLengthRef.current && data.length > 0) {
            handleCloseLoading();
        }

        prevLengthRef.current = data.length;
    }, [data.length, handleCloseLoading, isLoading]);

    // Timeout fallback sau 10s nếu vẫn loading
    useEffect(() => {
        if (!isLoading) return;

        const id = setTimeout(() => handleCloseLoading(), 10_000);
        return () => {
            clearTimeout(id);
        };
    }, [handleCloseLoading, isLoading]);

    if (data.length === 0 && !isLoading) {
        return <Empty />;
    }

    return (
        <div className="mt-4">
            {isLoading && (
                <div className="mx-auto flex justify-center mt-10 mb-14">
                    <SpinLoading />
                </div>
            )}

            {data.map((item, index) => (
                <Item key={index} item={item} index={index} />
            ))}
        </div>
    );
}
